import { CookieConsentBanner, type CookieConsentValues } from '@fontbold/ui';
import { useCookieConsent } from '#/lib/consent';
import { initSentry } from '#/lib/sentry';
import { COOKIE_CONSENT_TRANSLATIONS } from '#/lib/translations';

export function AppCookieConsent() {
  const { decided, functional, analytics, acceptAll, rejectAll, save } =
    useCookieConsent();

  const withAnalyticsInit = (values: CookieConsentValues) => {
    if (values.analytics) initSentry();
  };

  return (
    <CookieConsentBanner
      open={!decided}
      translations={COOKIE_CONSENT_TRANSLATIONS}
      values={{ functional, analytics }}
      onAcceptAll={() => {
        acceptAll();
        withAnalyticsInit({ functional: true, analytics: true });
      }}
      onRejectAll={rejectAll}
      onSave={(values) => {
        save(values);
        withAnalyticsInit(values);
      }}
    />
  );
}
